function formatAge(timestamp) {
  if (!timestamp) return 'saved earlier';
  const ageMs = Date.now() - timestamp;
  if (ageMs < 60 * 1000) return 'updated just now';
  const mins = Math.floor(ageMs / (60 * 1000));
  if (mins < 60) return `updated ${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `updated ${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `updated ${days}d ago`;
}

/**
 * Subtle banner when cached content is shown after a failed or slow refresh.
 */
export default function StaleDataBanner({
  visible = false,
  dataUpdatedAt,
  isFetching = false,
  message,
  className = '',
}) {
  if (!visible) return null;

  const label =
    message ||
    (isFetching
      ? 'Showing saved data · refreshing…'
      : `Showing saved data · ${formatAge(dataUpdatedAt)}`);

  return (
    <div
      role="status"
      className={`rounded-lg border border-warn-ring bg-warn-fill px-3 py-2 text-sm text-warn ${className}`}
    >
      {label}
    </div>
  );
}

export { formatAge };
